import React, { useState } from 'react';
import { Form, Button, Alert, Card, Col, Row } from 'react-bootstrap';
import api from 'helpers/api';
import Logo from 'components/common/LogoLogin';
import Section from 'components/common/Section';
import * as XLSX from 'xlsx';
// import ReactExport from 'react-data-export'

const ExportDemonstrative = () => {
    const [nrProcesso, setNrProcesso] = useState("")

    async function handleSubmit () {        
        const processo = nrProcesso.replace(/\//g, '&')
        const qtdAplicacao = await api.get(`/api/empresas/aplicacaoprocesso/${processo}`)
        for (let i = 0; i < qtdAplicacao.data.aplicacao.length; i++) {
            criaDespesa(qtdAplicacao.data.aplicacao[i].aplicacao)
            //-- criaDemonstrativo(qtdAplicacao.data.aplicacao[i].aplicacao)
            teste(qtdAplicacao.data.aplicacao[i].aplicacao)
            criaDemonstrativoCliente(qtdAplicacao.data.aplicacao[i].aplicacao)
        }
    }

    const teste = async (aplicacao) => {
        const processo = nrProcesso.replace(/\//g, '&')
        const [nro, ano] = nrProcesso.split("/");
        const result = await api.get(`/api/empresas/demonstrativoitem/${processo}&${aplicacao}`);
        const jsonDat2a = result.data.despesa.map((data) => Object.values(data));
        // Cria um workbook
        const workbook = XLSX.utils.book_new();
        // Cria uma planilha
        const worksheet = XLSX.utils.aoa_to_sheet([
            [`Demonstrativo de Cálculo por Item - ${nrProcesso}`],
            [''],
            ['', ''],
            ['', ''],
            ['', ''],
            ['Importador', result.data.cabecalho[0]['razaosocial_emp'], 'CNPJ:', result.data.cabecalho[0]['cgc_emp']],
            ['Referência do Cliente:', result.data.cabecalho[0]['ident_cli_pro']],
            ['DI:', result.data.cabecalho[0]['di_pro'], 'Data de Registro:', result.data.cabecalho[0]['dtreg']],
            ['Taxa US$', result.data.cabecalho[0]['Valor1']],
            ['Adição', 'Item', 'Código', 'Descrição', 'Quantidade', 'Exportador', 'NCM', 'Unidade', 'Valor Mercadoria', 'Valor Aduaneiro', 'Desp. Aduaneiras', 'Frete', 'THC', 'Seguro', 'P. Líquido Unit.', 'P. Líquido', 'ICMS', 'ICMS ST', 'II Base', 'IPI Base', 'PIS Base', 'COFINS Base', 'II Aliquota', 'IPI Aliquota', 'PIS Aliquota', 'COFINS Aliquota', 'ICMS Aliquota', 'ICMS ST Aliquota', 'II Impostos', 'IPI Impostos', 'PIS Impostos', 'COFINS Impostos', 'ANTIDUMPING', 'Tx. Siscomex', 'Total', 'ICMS', 'ICMS ST']
        ]);

        jsonDat2a.map((row) => {
            return row.filter((_, colIndex) => colIndex !== 2);
        });

        const modifiedData = jsonDat2a.map((row) => {
            return row.filter((_, colIndex) => colIndex !== 2);
        });
        // Adiciona os dados do objeto JSON na linha 7    
        const startRow = 10;
        const startCol = 0;
        // Formata as colunas I a M como decimal
        XLSX.utils.sheet_add_aoa(worksheet, modifiedData, { origin: { r: startRow, c: startCol } });
        worksheet['A6'] = { t: 's', v: 'Adição', s: { alignment: { vertical: 'center', horizontal: 'center' }, font: { bold: true } } };
        const columnsToConvert = ['F', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN'];
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let col = 4; col <= 34; col++) { // Colunas E, I a AC
            for (let row = range.s.r; row <= range.e.r; row++) {
                const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
                const cell = worksheet[cellRef];
                if (cell) {
                    cell.t = 'n'; // Define o tipo da célula como número
                    cell.z = '#,##0.00'; // Formato de número decimal com duas casas decimais
                }
            }
        }

        // Adicionar totalizadores
        const lastRowIndex = result.data.despesa.length;
        // Adicionar a linha de totalização
        const totalRowNumber = lastRowIndex + 10; // Próxima linha após os dados e o cabeçalho
        const totalRow = {
            A: 'Total', B: '', C: '', D: '',
            E: result.data.total[0]['Quantidade'].replace('.', '-').replace(',', '.').replace('-', ','),
            F: '', G: '', H: '',
            I: result.data.total[0]['ValorMercadoria'].replace('.', '-').replace(',', '.').replace('-', ','),
            J: result.data.total[0]['ValorAduaneiro'].replace('.', '-').replace(',', '.').replace('-', ','),
            K: result.data.total[0]['DespesasAduaneiras'].replace('.', '-').replace(',', '.').replace('-', ','),
            L: result.data.total[0]['Frete'].replace('.', '-').replace(',', '.').replace('-', ','),
            M: result.data.total[0]['THC'].replace('.', '-').replace(',', '.').replace('-', ','),
            N: result.data.total[0]['Seguro'].replace('.', '-').replace(',', '.').replace('-', ','),
            O: result.data.total[0]['PLiquidoUnit'].replace('.', '-').replace(',', '.').replace('-', ','),
            P: '',
            Q: result.data.total[0]['ICMS'].replace('.', '-').replace(',', '.').replace('-', ','),
            R: '',
            S: result.data.total[0]['IIBase'].replace('.', '-').replace(',', '.').replace('-', ','),
            T: result.data.total[0]['IPIBase'].replace('.', '-').replace(',', '.').replace('-', ','),
            U: result.data.total[0]['PISBase'].replace('.', '-').replace(',', '.').replace('-', ','),
            V: result.data.total[0]['COFINSBase'].replace('.', '-').replace(',', '.').replace('-', ','),
            W: '',
            X: '',
            Y: '',
            Z: '',
            AA: '',
            AB: '',
            AC: result.data.total[0]['IIImpostos'].replace('.', '-').replace(',', '.').replace('-', ','),
            AD: result.data.total[0]['IPIImpostos'].replace('.', '-').replace(',', '.').replace('-', ','),
            AE: result.data.total[0]['PISImpostos'].replace('.', '-').replace(',', '.').replace('-', ','),
            AF: result.data.total[0]['COFINSImpostos'].replace('.', '-').replace(',', '.').replace('-', ','),
            AG: '',
            AH: result.data.total[0]['TXSiscomex'].replace('.', '-').replace(',', '.').replace('-', ','),
            AI: result.data.total[0]['Total'].replace('.', '-').replace(',', '.').replace('-', ','),
            AJ: result.data.total[0]['ICMSImpostos'].replace('.', '-').replace(',', '.').replace('-', ','),
            AK: result.data.total[0]['ICMSTImpostos'].replace('.', '-').replace(',', '.').replace('-', ',')
        };
        const emptyRowNumber = 3;
        XLSX.utils.sheet_add_aoa(worksheet, [['']], { origin: emptyRowNumber });
        XLSX.utils.sheet_add_json(worksheet, [totalRow], { origin: totalRowNumber, skipHeader: true });

        // Converte o workbook para um arquivo Excel binário
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let name = aplicacao === 3 ? 'CONSUMO' : 'REVENDA'
        const fileName = `Demonstrativo de Cálculo por Item - ${nro}-${ano} - ${name}.xlsx`;

        if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
            // For IE browser
            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
        } else {
            // For other browsers
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    const criaDespesa = async (aplicacao) => {
        const processo = nrProcesso.replace(/\//g, '&')
        const [ nro, ano] = nrProcesso.split("/");
        //Traz as depesas Aduaneiras com rateio
        const result = await api.get(`/api/empresas/despaduaneira/${processo}&${aplicacao}`);        
        let name = aplicacao === 3 ? 'CONSUMO' : 'REVENDA';
        const worksheet = XLSX.utils.json_to_sheet(result.data.despesa);
        // Convert column B to a decimal format
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let rowNum = range.s.r + 1; rowNum <= range.e.r; rowNum++) {
            const cellRef = XLSX.utils.encode_cell({ r: rowNum, c: 1 });
            if (worksheet[cellRef] && worksheet[cellRef].t === 's') {
                const cellValue = parseFloat(worksheet[cellRef].v);
                worksheet[cellRef].t = 'n'; // Change cell type to numeric
                worksheet[cellRef].v = Number.isNaN(cellValue) ? null : cellValue; // Assign the parsed decimal value
                worksheet[cellRef].z = '0.00'; // Set the decimal number format (two decimal places)
            }
        }
        // Adicionar totalizadores
        const lastRowIndex = result.data.despesa.length;
        // Adicionar a linha de totalização
        const totalRowNumber = lastRowIndex + 1; // Próxima linha após os dados e o cabeçalho
        const totalRow = {
            A: 'Total', B: '', C: '', D: '',
            B: result.data.total[0]['valor'].replace('.', '-').replace(',', '.').replace('-', ',')
        };
        XLSX.utils.sheet_add_json(worksheet, [totalRow], { origin: totalRowNumber, skipHeader: true });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const fileName = `Despesas Aduaneiras ${nro}-${ano} - ${name}.xlsx`;


        if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
            // For IE browser
            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
        } else {
            // For other browsers
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

    }

    const criaDemonstrativoCliente = async (aplicacao) => {
        const processo = nrProcesso.replace(/\//g, '&')
        const [ nro, ano] = nrProcesso.split("/");
        //Traz as depesas Aduaneiras com rateio
        const result = await api.get(`/api/empresas/demonstrativocliente/${processo}&${aplicacao}`);
        const worksheet = XLSX.utils.json_to_sheet(result.data.despesa);
        // Columns to convert to decimal format: I, J, K, L, M, N, O, P, Q
        const columnsToConvert = ['C', 'D', 'E'];

        const range = XLSX.utils.decode_range(worksheet['!ref']);

        for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
            const column = XLSX.utils.encode_col(colNum);

            if (columnsToConvert.includes(column)) {
                for (let rowNum = range.s.r + 1; rowNum <= range.e.r; rowNum++) {
                    const cellRef = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                    if (worksheet[cellRef] && worksheet[cellRef].t === 's') {
                        const cellValue = parseFloat(worksheet[cellRef].v.replace(',', '.'));
                        worksheet[cellRef].t = 'n'; // Change cell type to numeric
                        worksheet[cellRef].v = Number.isNaN(cellValue) ? null : cellValue; // Assign the parsed decimal value
                        worksheet[cellRef].z = '0.00'; // Set the decimal number format (two decimal places)
                    }
                }
            }
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let name = aplicacao === 3 ? 'CONSUMO' : 'REVENDA'
        const fileName = `Demonstrativo Cliente - ${nro}-${ano} - ${name}.xlsx`;

        if (typeof window !== 'undefined' && window.navigator && window.navigator.msSaveOrOpenBlob) {
            // For IE browser
            window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
        } else {
            // For other browsers
            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    return (
        <>
            <Section className="py-0">
                <Row className="flex-center min-vh-100 py-6">
                    <Col sm={10} md={8} lg={6} xl={5}>
                        <Card>
                            <Logo width={200} className="mt-3" />
                            <Card.Body className="p-4 p-sm-5">
                                <Form >
                                    <Form.Group className="d-flex align-items-center">
                                        <Form.Control
                                            type="text"
                                            placeholder="Processo"
                                            required
                                            onChange={(e) => setNrProcesso(e.target.value)}
                                            className="me-2"
                                            style={{ width: '190px' }} // Ajuste o valor conforme necessário
                                        />
                                        <Button
                                            variant="primary"
                                            type="button"
                                            className="mt-2 mt-sm-0" // Adiciona margem superior em telas pequenas
                                            style={{ padding: '10px 10px', fontSize: '16px' }}
                                            onClick={handleSubmit}
                                        >
                                            Gerar Arquivo
                                        </Button>
                                    </Form.Group>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Section>
        </>
    );
};

export default ExportDemonstrative;